export default __webpack_public_path__ + "static/media/mariaFilo_desk_banner_2.a12a22d1.jpg";